import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import UnpublishedIcon from '@mui/icons-material/Unpublished';

import { postData } from "../func/api";
import { useAuth } from "../contexts/AuthContext"; 
import { BoxFlexEndTopMarginBR } from '../style/box'
import { ReportStopButton } from '../style/button'
import { BaseDialog } from "./base_dialog";

export default function ReportStopDialog({initial_report_uuid, earthquake_uuid}) {
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleClickOpen = () => {
    setOpen(true);
    setErrorMessage("");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleReportStop = async () => {
      try {
          if (initial_report_uuid || earthquake_uuid) {
            const payload = {
              earthquake_uuid: earthquake_uuid,
              initial_report_uuid: initial_report_uuid,
              user_uuid: currentUser.id,
            };
            await postData("api/post_report_stop", payload);
          }
          localStorage.setItem("taskStatus", 0);
          localStorage.removeItem("baseTime");
          window.location.href = `/earthquake_list`;
      } catch (error) {
          console.error("業務途中終了に失敗しました:", error);
          setErrorMessage("業務途中終了に失敗しました。もう一度お試しください。");
      }
      setOpen(false);
  };

  return (
    <>
      <BoxFlexEndTopMarginBR>
          <ReportStopButton startIcon={<UnpublishedIcon />} onClick={handleClickOpen}>
            業務途中終了
          </ReportStopButton>
          <BaseDialog
              open={open}
              onClose={handleClose}
              title={"業務を途中で終了"}
              message={"報告業務を途中で終了します。\n よろしいですか？"}
              onConfirm={handleReportStop}
              confirmText='OK'
              cancelText='キャンセル'
          />
      </BoxFlexEndTopMarginBR>
    </>
  );
}
